module.exports = __webpack_public_path__ + "img/star.4459338e.png";